// modules
import FetchService from 'modules/Fetch';

class WatchlistFetchService {
  // DONE
  getAllLists = async () => {
    const response = await FetchService.request<'WATCHLISTS_V3', WatchlistV3Response>(
      'WATCHLISTS_V3',
      '/user',
      'WATCHLISTS',
      {
        withDeviceDetails: true,
        addUUID: false,
      },
    );

    return response;
  };

  getWatchlistById = async (watchlistId: string) => {
    const response = await FetchService.request<'WATCHLISTS_V3', WatchlistDetailsResponse>(
      'WATCHLISTS_V3',
      '/user',
      `WATCHLISTS_V3_${watchlistId}` as LoadingKey,
      { pathParameter: watchlistId },
    );

    return response;
  };

  // DONE
  createWatchlist = async (name: string, items: string[]) => {
    const response: CreateWatchlistResponse = await FetchService.request(
      'WATCHLISTS',
      '/user',
      'CREATE_WATCHLIST',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          data: {
            watchlists: [
              {
                name,
                items,
              },
            ],
          },
        },
      },
    );

    return response;
  };

  // DONE
  deleteWatchlist = async (
    watchlistName: string,
    path: '/user' | '/user/unfollow',
    loadingKey: LoadingKey,
  ) => {
    const response = await FetchService.request(
      'WATCHLISTS',
      path,
      loadingKey,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        pathParameter: watchlistName,
      },
    );

    return response;
  };

  // DONE
  renameWatchlist = async (oldName: string, newName: string) => {
    await FetchService.request('WATCHLISTS', '/user', 'UPDATE_WATCHLIST', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        data: {
          oldName,
          newName,
        },
      },
    });
  };

  // DONE
  updateWatchlist = async (
    name: string,
    items: string[],
    method: HttpMethods = 'POST',
  ) => {
    const response = await FetchService.request(
      'WATCHLISTS',
      '/user',
      'UPDATE_WATCHLIST',
      {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          data: {
            name,
            items,
          },
        },
        pathParameter: method !== 'PUT' ? name : undefined,
      },
    );

    return response;
  };
}

export default new WatchlistFetchService();
